import {
  EmailVerifyWrapper,
  EmailVerifyIconCircle,
  EmailVerifyIcon,
  EmailVerifyHeading,
  EmailVerifyText,
} from "./style";
import { Text, Flex } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_NAMES } from "../../../constants/navigation-routes";

export const AwaitingApproval = () => {
  const { t } = useTranslation("common");
  const location = useLocation();
  const navigate = useNavigate();
  const companyName = location.state?.companyName;

  return (
    <Flex h={"90vh"} align="center" justify="center" bg="#F7F7FB" width="100vw">
      <EmailVerifyWrapper>
        <EmailVerifyIconCircle>
          <EmailVerifyIcon />
        </EmailVerifyIconCircle>

        <EmailVerifyHeading>{t("awaitingApproval.title")}</EmailVerifyHeading>

        <EmailVerifyText marginBottom={"24px"}>
          {t("awaitingApproval.subTitle")}&nbsp;
        </EmailVerifyText>

        <EmailVerifyText>
          {t("awaitingApproval.linkLabel")}
          <Text
            as="span"
            color="#1819B4"
            cursor="pointer"
            fontSize={"16px"}
            fontWeight={500}
          >
            {companyName || "-"}
          </Text>
        </EmailVerifyText>

        <EmailVerifyText marginTop={"24px"}>
          {t("awaitingApproval.loginPrompt")}&nbsp;
          <Text
            as="span"
            color="#1819B4"
            cursor="pointer"
            fontSize={"16px"}
            fontWeight={500}
            textDecoration="underline"
            onClick={() => navigate(ROUTE_NAMES.JOURNALIST_LOGIN)}
            _hover={{ color: "#0F0F7A" }}
          >
            {t("login.loginLink")}
          </Text>
        </EmailVerifyText>
      </EmailVerifyWrapper>
    </Flex>
  );
};
